import { View, Link, Text } from '@react-pdf/renderer';
import { Span } from '..';
import { en } from '../../theme/languages/en';
import { RECEIVED_LANDING_PAGE } from '../../utils';
import { styles } from './Footer.module';

export const Footer = ({ children }: { children?: JSX.Element }) => {
  return (
    <View style={styles.container} fixed>
      <View style={styles.flexColumn}>
        <Text
          style={[styles.text, { marginTop: 5 }]}
          render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        />
        <Span style={styles.text}>
          {en.poweredBy}{' '}
          <Link style={styles.text} src={RECEIVED_LANDING_PAGE}>
            {en.received}
          </Link>
        </Span>
      </View>

      {children}
    </View>
  );
};
